import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from '../../hook/Translation';

export default function BigCard({ data, textAlign, extraStyle, bgColor, extraImageStyle, bgImage }) {
    const {t} = useTranslation();
    return (
        <Grid container height={data.height ?? 1} position='relative' flexDirection={data.flexDirection ?? {md: 'row', xs: 'column-reverse'}} sx={extraStyle}>
            {
                data?.imageUrl &&
                <Grid size={data.imageSize ?? { md: 6, xs: 12 }} height={{ md: '100%', xs: '100%' }} zIndex={{ md: 1, xs: 'unset' }} sx={[bgImage ?? { backgroundColor: '#1e353d' }, extraImageStyle]}>
                    <Box component={'img'} src={data?.imageUrl} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </Grid>
            }
            <Grid size={data.size ?? { md: 6, xs: 12 }} paddingY={{ md: 'unset', xs: '20px' }} bgcolor={bgColor ?? { md: '#1e353d', xs: 'RGBA(33, 51, 59, 0.5)' }}>
                <Box height={'100%'} width={'80%'} marginX={'auto'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Grid container spacing={8}>
                        <Grid size={12}>
                            <Grid container spacing={3}>
                                <Grid size={12}>
                                    <Typography variant="body1" component={'p'} color='text.primary' gutterBottom fontWeight={'bold'}>{data?.type}</Typography>
                                    <Typography variant="h4" color='text.primary' fontFamily={'DanmarkURW'} fontSize={{md: '46px', xs: '38px'}} fontWeight={'bold'}>{data?.title}</Typography>

                                </Grid>
                                <Grid size={data.descriptionSize ?? { md: 10, xs: 12 }}>
                                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }} component={'p'} color='text.primary'>
                                        {data?.description}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={data?.btnContainer ?? { md: 10, xs: 12 }}>
                            <Grid container spacing={2}>
                                {
                                    data?.book &&
                                    <Grid size={{md: 6, xs: 12}}>
                                        <Button LinkComponent={Link} to={data?.book ?? '/'} fullWidth variant='contained' sx={{ maxHeight: '50px', minWidth: '246px', maxWidth: '246px', fontSize: '17px', fontWeight: 'bold' }} className='defaultButton borderRadiusFlat borderWidth2 buttonPaddingY10 noShadow placeBorder whiteBorderColor'>
                                            {
                                            data.bookName ??
                                            t('book_now')
                                            }
                                        </Button>
                                    </Grid>
                                }
                                {
                                    data?.learn &&
                                    <Grid size={{md: 6, xs: 12}}>
                                        <Button LinkComponent={Link} to={data?.learn ?? '/'} fullWidth variant='outlined' sx={{ maxHeight: '50px', minWidth: '246px', fontSize: '17px', fontWeight: 'bold', width: '246px' }} className='defaultButton borderRadiusFlat borderWidth2 buttonPaddingY10 noShadow placeBorder whiteBorderColor'>
                                            {t('learn_more')}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    )
}